// extracted by mini-css-extract-plugin
var _1 = "OnboardingActionButton-module__button--kYVmg";
var _2 = "OnboardingActionButton-module__desktopOnly--Zcd5l";
var _3 = "OnboardingActionButton-module__mobileOnly--nrXVP";
var _4 = "OnboardingActionButton-module__outline--SSqFF";
var _5 = "OnboardingActionButton-module__primary--k1NEr";
export { _1 as "button", _2 as "desktopOnly", _3 as "mobileOnly", _4 as "outline", _5 as "primary" }
